import { elakayAutoText } from "../../pageInside/dataElakay";
// Dropshipping Interne Elakay -- constantes frontend.
// Miroir de server_elakay/dropshippingInterne/constants.js -- garder les deux
// synchronisés à la main (pas de partage de build entre front/back ici).
// Indépendant de tout ce qui touche CJ Dropshipping/Printful/Printify/Syncee
// (le "Provider" ici est un rôle Elakay natif, pas une plateforme externe).

export const ROUTE_PREFIX = "/internal-dropshipping";

export const COMMERCIAL_MODES = Object.freeze({
  WHOLESALE: "wholesale",
  WHOLESALE_PROVIDER_STORAGE: "wholesale_provider_storage",
  DROPSHIPPING_INTERNE: "dropshipping_interne",
});

export const FULFILLMENT_MODES = Object.freeze({
  SELLER_STOCK: "SELLER_STOCK",
  PROVIDER_STOCK_SELLER_OWNED: "PROVIDER_STOCK_SELLER_OWNED",
  PROVIDER_DROPSHIPPING: "PROVIDER_DROPSHIPPING",
  PROVIDER_WHOLESALE_SHIPPING: "PROVIDER_WHOLESALE_SHIPPING",
});

export const PRODUCT_STATUSES = ["draft", "active", "inactive", "archived"];

// spec §4 -- une nouvelle ligne de palier vide par défaut, jamais une liste
// de quantités figées en dur.
export const emptyQuantityTier = () => ({
  minQuantity: "",
  maxQuantity: "",
  pricingType: "unitPrice", // "unitPrice" | "discountPercent" -- exclusif, voir ProviderProductPriceTiers.jsx
  unitPrice: "",
  discountPercent: "",
});

// spec §10 -- options booléones du Provider Product, regroupées et
// documentées ici pour que le formulaire (ProviderAddProduct.jsx) et toute
// future page d'édition les listent de façon identique, jamais dans un ordre
// différent ou avec un libellé divergent.
export const PRODUCT_BOOLEAN_OPTIONS = [
  { key: "wholesaleEnabled", get label() { return elakayAutoText("h_d3c2049e85bc44", "Wholesale (bulk purchase by Sellers)"); } },
  { key: "dropshippingEnabled", get label() { return elakayAutoText("h_ebf9b56c6782fe", "Dropshipping Interne (Seller doesn't need to buy stock upfront)"); } },
  { key: "paidDropshippingEnabled", get label() { return elakayAutoText("h_713205030348e4", "Paid Dropshipping (extra service fee on dropshipping orders)"); } },
  { key: "providerStorageEnabled", get label() { return elakayAutoText("h_b45f2a78b811f9", "Provider Storage (goods stay physically at the Provider after a wholesale purchase)"); } },
  { key: "paEnabled", get label() { return elakayAutoText("h_418064cbb3224f", "PA discounts apply to this product"); } },
  { key: "shippingByProviderEnabled", get label() { return elakayAutoText("h_066a8a7256877e", "Provider can ship on the Seller's behalf"); } },
  { key: "sellerPickupEnabled", get label() { return elakayAutoText("h_874964ed2b27a3", "Seller pickup available"); } },
  { key: "localDeliveryEnabled", get label() { return elakayAutoText("h_6d2e5899c7a571", "Local delivery available"); } },
];
